<template>
  <div class="base-token">
    <bronze-token v-if="type === bronze"></bronze-token>
    <silver-token v-else-if="type === silver"></silver-token>
    <orange-token v-else-if="type === orange"></orange-token>
  </div>
</template>

<script>
import {BRONZE, SILVER, ORANGE} from '../../../source/constants/tokens';

import BronzeToken from './BronzeToken';
import OrangeToken from './OrangeToken';
import SilverToken from './SilverToken';

export default {
  props: {
    type: String
  },
  data() {
    return {
      bronze: BRONZE,
      silver: SILVER,
      orange: ORANGE
    };
  },
  components: {BronzeToken, OrangeToken, SilverToken}
};
</script>

<style lang="scss" scoped>
.base-token {
  border-radius: 50%;
  svg {
    position: relative;
    top: 5px;
  }
}
</style>
